import classNames from "classnames";
import { createElement } from "react";

export const Button = ({
  children,
  center,
  rounded,
  variant = "primary",
  as = "button",
  ...props
}: {
  center?: boolean;
  rounded?: boolean;
  variant?: "primary" | "secondary";
  as?: "a" | "button";
} & (
  | React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >
  | React.DetailedHTMLProps<
      React.AnchorHTMLAttributes<HTMLAnchorElement>,
      HTMLAnchorElement
    >
)) => {
  const variantDefaults = {
    primary: {
      bg: "bg-accent",
      border: "rounded-lg",
      font: "uppercase",
    },
    secondary: {
      bg: "bg-primary",
      border: "",
      font: "",
    },
  };
  const styles = { ...variantDefaults[variant] };
  if (rounded) {
    styles.border = "rounded-lg";
  }
  return createElement(
    as,
    {
      className: classNames(
        "block text-white py-2 px-6",
        {
          "self-center": center,
        },
        Object.values(styles)
      ),
      ...props,
    },
    children
  );
};
